import { ChevronDownIcon } from '@heroicons/react/24/outline';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/Dropdown';
import { useFancyRendering } from '@/components/RichTextEditor/utils/fancyRenderContext/useFancyRender';
import { Button, Tooltip } from '@/design-system';
import { capitalizeWords } from '@/utils/stringUtils';

export function RunDetailsHeaderToggle(props: {
  raw: boolean;
  readOnly?: boolean;
  customIframe?: boolean;
  onRawChange: (value: boolean) => void;
  variant: 'input' | 'output' | 'reference output';
  disabled?: boolean;
  disabledMessage?: string;
}) {
  const subject = capitalizeWords(props.variant);

  const { setFancyRendering } = useFancyRendering();

  const triggerContent = (
    <span className="text-lg font-medium">
      {props.customIframe && !props.raw
        ? `Custom Rendered ${subject}`
        : props.raw
        ? `Raw ${subject}`
        : subject}
    </span>
  );
  return props.readOnly ? (
    <div className="mb-2 inline-flex items-center gap-2 outline-none">
      {triggerContent}
    </div>
  ) : (
    <DropdownMenu>
      <Tooltip title={props.disabled ? props.disabledMessage : ''}>
        <DropdownMenuTrigger
          className="group mb-2 inline-flex items-center gap-2 outline-none"
          disabled={props.disabled}
        >
          <Button
            variant="plain"
            color="secondary"
            size="sm"
            rightDecorator={ChevronDownIcon}
            data-testid={`run-details-header-toggle-${props.variant}`}
          >
            {triggerContent}
          </Button>
        </DropdownMenuTrigger>
      </Tooltip>
      <DropdownMenuContent align="start">
        <DropdownMenuItem
          onClick={() => {
            props.onRawChange(false);
            setFancyRendering(true);
          }}
          className="flex-col items-start"
        >
          <span>Default</span>
          <span className="text-sm text-tertiary">
            Attempt to render messages and documents
          </span>
        </DropdownMenuItem>

        <DropdownMenuItem
          onClick={() => {
            props.onRawChange(true);
            setFancyRendering(false);
          }}
          className="flex-col items-start"
        >
          <span>Raw {subject}</span>
          <span className="text-sm text-tertiary">
            Render the payload received by LangSmith
          </span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
